import { useMemo } from "react";
import { Link } from "react-router-dom";
import { WORKS } from "@/mocks/works";
import WorkCard from "@/components/base/WorkCard";
import RankingItem from "@/components/base/RankingItem";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function TopRated() {
  usePageMeta({
    title: "韩漫高分作品推荐｜口碑佳作、高评分韩漫大全",
    description:
      "人气韩漫大全高分榜精选评分口碑俱佳的韩漫佳作，从玄幻、恋爱到动作、恐怖，高分作品一目了然，帮你快速锁定值得追的高分韩漫。",
    path: "/top-rated",
  });

  const list = useMemo(() => [...WORKS].sort((a, b) => b.rating - a.rating), []);
  const podium = list.slice(0, 3);
  const rest = list.slice(3);

  return (
    <div className="mx-auto max-w-7xl px-4 py-24 md:px-6 md:py-28">
      <nav className="mb-6 text-xs text-foreground-500" aria-label="面包屑">
        <ol className="flex flex-wrap items-center gap-1.5">
          <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
          <li><i className="ri-arrow-right-s-line"></i></li>
          <li aria-current="page" className="text-foreground-700">高分佳作</li>
        </ol>
      </nav>

      <div className="max-w-2xl">
        <p className="font-label text-xs font-semibold uppercase tracking-widest text-secondary-600">Top Rated</p>
        <h1 className="mt-1 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">韩漫高分佳作推荐</h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          综合读者评分与口碑沉淀，精选当前口碑俱佳的韩漫高分作品。高分不代表人人喜爱，但通常拥有更强的剧情、画风与完成度，适合作为优质入门首选。
        </p>
      </div>

      <ol className="mt-10 grid grid-cols-1 gap-3 md:grid-cols-3">
        {podium.map((work, i) => (
          <RankingItem key={work.id} work={work} rank={i + 1} showPop={false} />
        ))}
      </ol>

      <div className="mt-12">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">高分榜完整列表</h2>
        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {rest.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>

      <p className="mt-10 text-center text-xs text-foreground-500">
        评分综合读者评分与榜单口碑实时统计，仅供参考。高分韩漫推荐会随人气与口碑动态更新。
      </p>
    </div>
  );
}